<template>
  <div class="nav-vertical nav-vertical--nested filterItemCategoryContainer" style="display: block">
    <div
      class="nav-vertical__item flex-wrap cursor-pointer py-0"
      :class="[selectedCategory ? 'idontlooklikealink' : '']"
    >
      <div class="backButtonContainer">
        <c-back-button
          tabindex="0"
          v-if="selectedTag"
          @click="onBackButtonClicked"
          @keyup.enter="onBackButtonClicked"
          @keyup.space="onBackButtonClicked"
          :aria-label="`Back to ${name}`"
        ></c-back-button>
        <button
          :id="isFirstCategory ? 'theFirstCategory' : ''"
          :aria-label="ariaLabel || `Health condition category: ${name} ${count} results `"
          :aria-expanded="selectedCategory ? 'true' : 'false'"
          @click="onCategorySelected(); resetFocus()"
          @keyup.enter="onCategorySelected(); resetFocus()"
          @keyup.space="onCategorySelected(); resetFocus()"
          class="filter-btn px-2 ml-1"
          :class="[isFirstCategory, selectedCategory ? 'idontlooklikealink focusHere remove-padding' : 'remove-padding']"
          :tabindex="selectedCategory && selectedTag ? '-1' : '0'"
          ref="filterItemCategorySelector"
          :key="wasClickedCat"
          ><h3 class="new-h3">{{ name }}</h3></button
        >
      </div>
      <span tabindex="-1" ml-1 v-if="count" aria-hidden="true">({{ count }})</span>
    </div>
    <c-filter-item-tags
      :tags="visibleTags"
      v-if="showTags"
      @tag-selected="onTagSelected"
      @reset-tag="$emit('reset-tag')"
    ></c-filter-item-tags>
    <div class="visuallyhidden">
      <span>{{ tagsAvailableText }}</span>
    </div>
  </div>
</template>

<script>
import FilterItemTags from '@/components/pages/filter/categories/FilterItemTags'

export default {
  components: { 'c-filter-item-tags': FilterItemTags },
  // data: () => ({}),
  data() {
    return {
      componentKey: 0,
      componentKeyCat: 0,
    }
  },
  props: {
    ariaLabel: String,
    count: [Number, String],
    id: [Number, String],
    isFirstCategory: Boolean,
    name: { required: true, type: String },
    tags: { required: true, type: Array },
    showTags: Boolean,
  },
  computed: {
    allCategoriesAndTags() {
      return this.$store.getters['search/allCategoriesAndTags']
    },
    selectedCategory() {
      return this.$store.getters['search/selectedCategory']
    },
    selectedTag() {
      return this.$store.getters['search/selectedTag']
    },
    tagsAvailableText() {
      const { selectedCategory, selectedTag, visibleTags } = this
      return selectedCategory && !selectedTag
        ? `Health condition category: ${selectedCategory} expanded ${visibleTags.length} subcategories available.`
        : ''
    },
    visibleTags() {
      if (this.selectedTag) return [this.selectedTag]
      else return this.tags
    },
    wasClicked() {
      // this.disabled = disabled
      return this.$store.getters['search/wasClickedCat']
    },
  },
  mounted() {
    this.resetFocus();
  },
  methods: {
    onBackButtonClicked() {
      this.onResetTag()
      this.$store.commit('search/setWasClicked', (this.componentKey += 1))
      this.$store.commit('search/setWasClickedCat', (this.componentKeyCat += 1))
    },
    onCategorySelected() {
      const { getActiveCategoryFromTag, selectedCategory, selectedTag } = this
      if (!selectedCategory) this.$emit('category-selected', this.id)
      
    },
    onTagSelected(e) {
      if (e !== this.selectedTag) this.$emit('tag-selected', e)
      else this.onResetTag()
    },
    onResetTag() {
      this.$emit('reset-tag')
    },
    resetFocus() {
       this.$nextTick(() => {
         try{
        document.getElementsByClassName("focusHere")[0].focus();
         }
         catch(err){
           
         }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
 .new-h3 {
   display: inline-block; 
   padding: 0 0 0 0.5em !important;
 }

 .remove-padding {
   padding: 0 !important;
 }
</style>